import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BANK_FEATURE_KEY, EpimsBankState, EpimsBankPartialState, bankAdapter } from './bank.reducer';

// Lookup the 'EpimsBank' feature state managed by NgRx
export const getEpimsBankState = createFeatureSelector<EpimsBankPartialState, EpimsBankState>(BANK_FEATURE_KEY);

const { selectAll, selectEntities } = bankAdapter.getSelectors();

export const getEpimsBankLoaded = createSelector(getEpimsBankState, (state: EpimsBankState) => state.loaded);

export const getEpimsBankError = createSelector(getEpimsBankState, (state: EpimsBankState) => state.error);

export const loadingEpimsBank = createSelector(getEpimsBankState, (state: EpimsBankState) => state.loaded);

export const getAllEpimsBank = createSelector(getEpimsBankState, (state: EpimsBankState) => selectAll(state));

export const getEpimsBankEntities = createSelector(getEpimsBankState, (state: EpimsBankState) => selectEntities(state));

export const getSelectedId = createSelector(getEpimsBankState, (state: EpimsBankState) => state.selectedEpimsBankId);

export const getSelected = createSelector(
	getEpimsBankEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
